const mod = require('../bahabot.module.js')

mod.component('bbLoginLayout', {
    templateUrl: 'tpl/layouts/login.layout.html',
    bindings: {},
    controller: ["ThemeService", function(ThemeService) {
        var ctrl = this
        ctrl.isDark = ThemeService.isDark

        ctrl.toggleTheme = function() {
            ThemeService.toggle()
            ctrl.isDark = ThemeService.isDark
        }
    }]
});